import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";

export function Overlay({ open, onClose, children, testId, className = "max-w-lg", z = "z-50", solid = false }) {
  useEffect(() => {
    if (!open || !onClose) return;
    const h = (e) => { if (e.key === "Escape") { e.stopImmediatePropagation(); onClose(); } };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [open, onClose]);
  useEffect(() => {
    if (!open) return;
    document.body.dataset.overlayOpen = "1";
    return () => { delete document.body.dataset.overlayOpen; };
  }, [open]);
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className={`fixed inset-0 ${z} flex items-end sm:items-center justify-center ${solid ? "bg-[#0B0E14]" : "bg-black/70 backdrop-blur-sm"}`}
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          onMouseDown={(e) => e.target === e.currentTarget && onClose?.()}
        >
          <motion.div
            data-testid={testId}
            className={`relative w-full ${className} max-h-[94vh] overflow-y-auto no-scrollbar bg-[#151A22] border border-white/10 rounded-t-3xl sm:rounded-3xl shadow-2xl`}
            initial={{ opacity: 0, y: 40, scale: 0.97 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 40, scale: 0.97 }}
            transition={{ type: "spring", stiffness: 320, damping: 30 }}
          >
            {onClose && (
              <button data-testid={`${testId}-close`} onClick={onClose} className="absolute right-4 top-4 z-10 p-1.5 rounded-full border border-white/20 text-gray-300 hover:bg-white/10 transition-colors">
                <X size={16} />
              </button>
            )}
            {children}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
